import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import usePageTitle from "../../hooks/usePageTitle";
import ScrollView from 'devextreme-react/scroll-view';
import { ROUTE_BASIC_SECURITY_DATA, ROUTE_WELCOME } from "../../routes/Routes";
import PutPostPatchFetch from "../../hooks/PutPostPatchFetch";
import { BasicSecurityForm } from '../../components/BasicSecurity/BasicSecurityForm';
import '../../sass/styles.scss';
import 'devextreme/dist/css/dx.light.css';
import './AddInformation.scss';


import { List } from 'devextreme-react/list';
import ClosingAlert from "../../components/ClosingAlert";
import { DateBox } from "devextreme-react";
import { Toast } from "devextreme-react/toast";
import { fileSizeConversion } from "../../util/FileSizeConversion";
import { BaseButton } from "../../components/BaseButton/BaseButton";
import { ValidationMessageItem } from "./ValidationMessageItem/ValidationMessageItem";

/** @typedef {import('../../types/basicSecurityData').BasicSecurityData} BasicSecurityData */

const BasicSecurityInformation = () => {
    const title = 'Add Basic Security Data'
    usePageTitle(title);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [_billingDate, set_BillingDate] = useState();
    const [data, setData] = useState(null);    
    const [successMessage, setSuccessMessage] = useState('');
    const [validationMessage, setValidationMessage] = useState([]);
    const [errorMessage, setErrorMessage] = useState(false);
    const [alertVisible, setAlertVisible] = useState(false);
    const [notification, setNotification] = useState({
        message: '',
        type: undefined,
        visible: false
    });

    const navigate = useNavigate();
    const navigateToRoute = () => navigate(ROUTE_WELCOME.withSlash);
    const fileInputRef = useRef(null);

    usePageTitle(title);

 /**
  * @name newContractData
  * @type {Contract}
  */
    
    const newBasicSecurityData = {
        Id: 0,
        BillDate: null,
        UploadFile: null,
    }

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        // setIsLoading(true);
        setData(newBasicSecurityData);
        console.log(data)
        // setIsLoading(false);
    };


    const handleFileUpload = (event) => {
        const files = Array.from(event.target.files);
        const { size } = event.target.files[0];
        const maxFileSize = 25000000; // 25 MB

        if (size && size >= maxFileSize) {
            setNotification({
                isVisible: true,
                message: 'The file you have selected is too large in size. Please choose a .csv file with a size that is under 25 MB.',
                type: 'error'
            });
        };
        
        if (size && size < maxFileSize) {
            setNotification({
                isVisible: true,
                message: 'File selection successful.',
                type: 'success'
            });
            setSelectedFiles(prevFiles => [...prevFiles, ...files]);
        };

        fileInputRef.current.value = "";
    };

    const RemoveSelectedFiles = async (event) => {
        event.preventDefault();
        selectedFiles.length = 0;
        setSelectedFiles(prevFiles => [...prevFiles, ...selectedFiles]);
     
    }
    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData();

        for (let i = 0; i < selectedFiles.length; i++) { 
            formData.append("Files", selectedFiles[i])
        };

        try {
            const { Errors, Message, Success } = 
                await PutPostPatchFetch(
                    `/v1/BasicSecurity/?billingDate=${_billingDate}`, 
                    'POST', 
                    formData, 
                    'multipart/form-data'
                );

            if (Success) {
                setAlertVisible(true);
                setErrorMessage(false);
                setSuccessMessage('Files submitted successfully!');
            } ;
            
            if (Errors) {
                setValidationMessage(Errors[0].ErrorMessages);
                setSuccessMessage(null);
                setErrorMessage(true);
            };
        } catch (error) {
            console.error('Error: ', error);
        }

    };

    const handleCloseAlert = () => {
        setAlertVisible(false);
    };

    const handleToastHiding = () => {
        setNotification(() => ({ 
            message: '',
            type: undefined, 
            isVisible: false
        }))
    };

    return (
        <div>
            <h1> {title} </h1>
            <ScrollView className='view-wrapper-scroll'>
                <div className='view-wrapper view-wrapper-contact-details'>
                    <div className='panels'>
                        <BasicSecurityForm
                        data={data}
                        fileExtensions= {['.csv']}
                        postPath='/v1/BasicSecurity/UploadData?billingDate='
                        backPath={ROUTE_BASIC_SECURITY_DATA.withSlash}
                        isLoading={false}
                        isEditing={true}
                        />
                    </div>
                </div>
            </ScrollView>

{/*             <div className="block block__div--wrapper">
                <DateBox
                    dateSerializationFormat="MM/dd/yyyy"
                    useMaskBehavior={true}
                    displayFormat="monthAndYear"
                    inputAttr={{
                        "aria-label": "Billing Date",
                        "aria-required": "true"
                    }}
                    label="Billing Date"
                    onValueChanged={(e) => set_BillingDate(e.value)}
                    showDropDownButton={false}
                    type="date"
                    value={_billingDate ?? null}
                    variant={"outlined"}
                />
            </div>
            <div className="block block__div--wrapper">
                <BaseButton
                    label={"Select file"}
                    onClick={() => document.getElementById('file-upload-input').click()}
                    variant={"outlined"}
                />
                <input
                    accept=".csv"
                    id="file-upload-input"
                    onChange={handleFileUpload}
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    type="file"
                />
                <BaseButton
                    aria-disabled={selectedFiles.length === 0}
                    disabled={selectedFiles.length === 0}
                    onClick={handleSubmit}
                    variant={"outlined"}
                    label={"Submit"}
                />
            </div>
            <div className="block">
                <div className={
                    selectedFiles.length === 0 ? 
                    "block__unscrollable-container" 
                    : 
                    "block__scrollable-container"
                    }>
                    {
                        !selectedFiles.length === 0 && 
                        <div className="inline__empty-list">                            
                            <span>
                                No File Selected
                            </span>
                        </div>
                    }
                    {
                        selectedFiles.length > 0 &&
                        <ul className="block__unordered-list">
                            {
                                selectedFiles.map(({
                                    index,
                                    name, 
                                    size
                                }) => {
                                    const formattedSize = fileSizeConversion(size);
                                    return (
                                        //TODO: Using name instead of index gets rid of error, but need to find a better indexing method
                                        <li key={name} className="inline__list-item">
                                            <span className="inline__span--file-name">
                                                {name} 
                                            </span>
                                            <span className="inline__span--file-size">
                                                {formattedSize}
                                            </span>
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    }
                </div> 
            </div> */}
               
            {/* <div className="block block__div--wrapper"> */}
                {/* <ToolbarForm toggleEditing={handleSubmit} onSaveClick={handleSubmit} editing={true} onCancelClick={RemoveSelectedFiles} /> */}
                {/* <BaseButton
                    label={"cancel"}
                    onClick={RemoveSelectedFiles}
                    variant={"outlined"}
                />
            </div> */}

{/*             {
                errorMessage &&
                <div className="list-container">
                    <>
                        <h2 className="h2--validation-errors"> Validation Errors </h2>
                        <List
                            dataSource={validationMessage}
                            height="100%"
                            itemRender={ValidationMessageItem}
                        />
                    </>
                </div>
            }            

            <ClosingAlert
                visible={alertVisible}
                hideAlert={handleCloseAlert}
                message={successMessage || errorMessage}
                severity={successMessage ? 'success' : 'error'}
                enableAlertIcon={true}
                clickableIcon={handleCloseAlert}
            />
            <Toast 
                animation={{
                    show: {
                        type: 'fade',
                        duration: 300,
                        from: 0,
                        to: 1
                    },
                    hide: {
                        type: 'fade',
                        duration: 300,
                        from: 1,
                        to: 0
                    }
                }}
                closeOnClick={true}
                displayTime={86400000}
                focusStateEnabled={true}
                message={notification.message}
                onHiding={handleToastHiding}
                type={notification.type}
                visible={notification.isVisible}
            /> */}
        </div>

    );
};

export default BasicSecurityInformation;
